import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import { Check } from 'lucide-react';

import CustomButton from '../../Componentization/CustomButton';
import CustomText from '../../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText, checkSelectQssIndex } from '../../../store';

import useSecureStorage from '../../../hooks/useSecureStorage';
import useQssMnemonic, { QssMnemonicHash } from '../../../hooks/useQssMnemonic';

import i18next from 'i18next'

import PinCodeScreen from '../../Authentication/PinCodeScreen';

/**
 * @brief QSS 니모닉 관리 페이지 스크린
 * @returns 
 */
const QssSettingMnemonicScreen = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const { getBlockChain, getLocalMnemonicHash } = useSecureStorage()
	const { checkOverlapQssMnemonicHash, getQssMnemonicHash } = useQssMnemonic()

	const [isDeleteModalVisible, setDeleteModalVisible] = useState(false)
	const [showPinCodeAuth, setShowPinCodeAuth] = useState(false)
	const [usingQssMnemonic, setUsingQssMnemonic] = useState(true)
	const [IsSavedQssMnemonic, setIsSavedQssMnemonic] = useState(true)
	const [qssMnemonicHashList, setQssMnemonicHashList] = useState<QssMnemonicHash[]>([]);
	const [selNetworkName, setSelNetworkName] = useState('')
	const [localMnemonicHash, setLocalMnemonicHash] = useState('')

	const maxQssMnemonicCount = Number(process.env.REACT_APP_QSS_MNEMONIC_MAX_COUNT) || 9;

	const items = [
		{ 
			text: i18next.t('qss_setting_screen_message_02'), 
			screen: 'QssSettingMnemonicPassword',
			hasSwitch: true, 
			hasBadge: true,
			extraText: null
		},
		// {
		// 	text: i18next.t('qss_setting_screen_message_03'),
		// 	screen: 'ChangePassword',
		// 	hasSwitch: false,
		// 	hasBadge: true,
		// 	extraText: null
		// },
		// {
		// 	text: i18next.t('security_setting_screen_message_04'),
		// 	screen: 'AutoLockScreen',
		// 	hasSwitch: false,
		// 	extraText: autoLockSetting
		// }
		// {
		// 	text: i18next.t('security_setting_screen_message_16'), // 휴대폰 인증 페이지
		// 	screen: 'VerifyPhoneScreen',
		// 	hasSwitch: false,
		// 	extraText: verifyEmail
		// }
	]

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "QssSettings", "title": t('stack_header_message_20') }))
	}, [])

	useEffect(() => {
		const checkQssUseStatus = async () => {
			// 지갑 생성/복구 시 현재 니모닉이 QSS에 저장된 상태인지 확인
			// const savedQssMnemonic = await getIsSavedQssMnemonic()
			// setIsSavedQssMnemonic(savedQssMnemonic)

			// 현제 선택된 네트워크
			const selNetwork = await getBlockChain()
			console.log(`QssSettingMnemonicScreen selNetwork`, selNetwork)

			if(null == selNetwork || '' === selNetwork) {
				setSelNetworkName(process.env.REACT_APP_NETWORK_NAME!)
			}
			else {
				setSelNetworkName(selNetwork)
			}

			// qss 저장된 니모닉해시
			const qssMnemonicHash = await getQssMnemonicHash(selNetwork)
			console.log(`QssSettingMnemonicScreen qss 저장된 니모닉해시 리스트`, qssMnemonicHash)
			if(false === qssMnemonicHash.result) {
				// QSS에 저장된 니모닉해시 데이터가 없음
				setUsingQssMnemonic(false)
				console.log(`QssSettingMnemonicScreen QSS에 저장된 니모닉 정보 없음`)
			} else {
				// QSS에 저장된 니모닉해시 데이터가 있음
				setUsingQssMnemonic(true)

				if(null != qssMnemonicHash.value) {
					const value:QssMnemonicHash[] = qssMnemonicHash.value
					console.log(`value QssMnemonicHash`, value)
					setQssMnemonicHashList(value)
				}
				
				console.log(`QSS에 저장된 니모닉 정보 있음`)
			}

			// 현재지갑의 니모닉해시
			const localHash = await getLocalMnemonicHash()
			console.log(`QssSettingMnemonicScreen localHash ${localHash}`)

			// 현재 지갑에 설정된 니모닉 해시가 QSS에 저장되어 있는지 확인
			const checkQssOverlapHash = await checkOverlapQssMnemonicHash(localHash, selNetwork)
			// console.log(`QssSettingMnemonicScreen checkQssMnemonicHash ${checkQssOverlapHash}`)

			setLocalMnemonicHash(localHash)

			if(true === checkQssOverlapHash) {
				// QSS 니모닉저장 서비스 사용안함
				// QSS에 저장된 니모닉 데이터가 없음
				// setUsingQssMnemonic(true)
				setIsSavedQssMnemonic(true)
				console.log(`QSS에 저장된 니모닉해시 정보 있음 2`)
			} else {
				// QSS 니모닉저장 서비스를 사용 중
				// QSS에 저장된 니모닉 데이터가 있음
				// setUsingQssMnemonic(false)
				setIsSavedQssMnemonic(false)
				console.log(`QSS에 저장된 니모닉해시 정보 없음 2`)
			}

			// TEST 임시 qSS 전체 clear
			// console.error(`QSS 전체 Clear`)
			// await clearQssMnemonic('solana');
			// await clearQssMnemonic('bsc');
			// await clearQssMnemonic('ton');
		}

		checkQssUseStatus()
	}, [])

	const handleItemPress = async (screen: string, mnemonicIndex: number) => {
		if (screen) {
			
			console.log(`QssSettingMnemonicScreen handleItemPress select mnemonicIndex ${mnemonicIndex}`)
			// 선택한 니모닉해시 인덱스 저장
			dispatch(checkSelectQssIndex(mnemonicIndex))

			navigate(`/${screen}`, { replace: true, state: {} });
		}
	}

	const handleNewQssMnemonic = async () => {
		navigate(`/QssSettingSecretPhraseWarning`, { replace: true, state: {} });
	}

    // qSS 전체 삭제
	const handleQssClearPress = async () => {
	}

    // qss 비밀번호 확인 성공
	const handleQssPasswordAuthSuccess = async (pin: string) => {
    }


	const styles = {
		container: {
			padding: "60px 5px 24px",
			position: "relative"
		} as React.CSSProperties,
		sectionTitleTop: {
			fontSize: 14,
			color: theme.text_15,
			width: "100%",
			paddingTop: "10px",
			paddingBottom: "10px",
			paddingLeft: "10px",
			paddingRight: "24px",
			boxSizing: "border-box"
		} as React.CSSProperties,
		sectionTitle: {
			fontSize: 14,
			color: theme.text_15,
			width: "100%",
			paddingTop: "20px",
			paddingBottom: "10px",
			paddingLeft: "10px",
			paddingRight: "24px",
			boxSizing: "border-box"
		} as React.CSSProperties,
		groupContainer: {
			borderRadius: 10,
			marginVertical: 8,
			overflow: 'auto',
		} as React.CSSProperties,
		item: {
			display: "flex",
            alignItems: 'center',
			justifyContent: "space-between",
            padding: "13px 15px",
            borderRadius: 10,
            marginBottom: 10,
            border: `1px solid ${theme.line_neutral}`,
			cursor: "pointer"
		} as React.CSSProperties,
		itemText: {
			fontSize: 18,
			color: theme.text_15,
			flex: 1
		} as React.CSSProperties,
		extraText: {
			color: theme.text_01,
			marginRight: 8
		} as React.CSSProperties,
		itemNetworkText: {
			fontSize: 18,
			color: theme.text_15,
		} as React.CSSProperties,
		arrowIcon: {
			width: 13,
			height: 21,
			tintColor: theme.text_03
		} as React.CSSProperties,
		topRounded: {
			borderTopLeftRadius: 10,
			borderTopRightRadius: 10,
		} as React.CSSProperties,
		bottomRounded: {
			borderBottomLeftRadius: 10,
			borderBottomRightRadius: 10,
			borderBottom: `0px solid ${theme.border_04}`
		} as React.CSSProperties,
		deleteText: {
			color: theme.text_17
		} as React.CSSProperties,
		modalBackground: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: theme.background_alternative,
			position: "absolute",
			width: "100%",
			height: "100%",
			top: 0,
			left: 0
		} as React.CSSProperties,
		modalContainer: {
			width: '90%',
			backgroundColor: 'white',
			borderRadius: 10,
			padding: '20px',
			border: `1px solid ${theme.border_09}`,
			boxSizing: "border-box"
		} as React.CSSProperties,
		modalTitle: {
			fontSize: 18,
			color: theme.text_17,
			textAlign: 'center',
			marginBottom: 10
		} as React.CSSProperties,
		modalMessage: {
			fontSize: 14,
			color: theme.text_02,
			textAlign: 'center'
		} as React.CSSProperties,
		modalButtons: {
			display: "flex",
			width: '100%',
			borderTop: `1px solid ${theme.border_10}`,
			marginTop: 20
		} as React.CSSProperties,
		cancelButton: {
			width: "100%",
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			padding: "10px 0",
			borderRight: `1px solid ${theme.border_10}`,
		} as React.CSSProperties,
		cancelButtonText: {
			color: theme.text_15,
			fontSize: 16
		} as React.CSSProperties,
		confirmButton: {
			width: "100%",
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
		} as React.CSSProperties,
		confirmButtonText: {
			color: theme.text_17,
			fontSize: 18
		} as React.CSSProperties,
		buttonPrimary: {
            backgroundColor: theme.background_04,
            padding: '12px',
            borderRadius: '10px',
            marginTop: '12px',
			marginBottom: '0px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            height: '54px',
            justifyContent: 'center',
        } as React.CSSProperties,
        buttonPrimaryText: {
            color: theme.static_white,
            fontSize: '16px',
            textAlign: 'center', // textAlignVertical은 웹에서는 textAlign으로 처리
        } as React.CSSProperties,
	}

	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_01 }}>
			{/* 현재지갑 QSS 니모닉해시에 저장된 상태 - QSS니모닉 리스트 표시*/}
			{true === IsSavedQssMnemonic && (
				<div style={{ width: "100%" }}>
					{/* QSS 니모닉 리스트 */}
					<CustomText style={{ ...styles.sectionTitleTop, color: theme.text_05 }}>
						{t('qss_setting_screen_message_09')}
					</CustomText>
					<div className='containerScroll' style={{ ...styles.groupContainer }} >
						{qssMnemonicHashList.map((item, index) => (
							item.network.toLowerCase() === selNetworkName.toLowerCase() && ( // 일치하는 네트워크만 표시
								item.mnemonicHash === localMnemonicHash && ( // 니모닉해시 일치하는 니모닉코드만 표시
									<div key={index} style={{ 
										...styles.item, 
										backgroundColor: theme.background_10,
										border: item.mnemonicHash === localMnemonicHash ? `1px solid ${theme.primary_normal}` : `1px solid ${theme.line_neutral}`
									}}>
										{item.name && (<CustomText style={{ ...styles.extraText, color: theme.text_01 }}>{item.name}</CustomText>)}
										<div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
										</div>
									</div>
								)
							)
						))}
					</div>


					{/* QSS 니모닉 리스트 */}
					<CustomText style={{ ...styles.sectionTitleTop, color: theme.text_05 }}>
						{t('qss_setting_screen_message_01')}
					</CustomText>
						{qssMnemonicHashList.map((item, index) => (
							item.network.toLowerCase() === selNetworkName.toLowerCase() && ( // 일치하는 네트워크만 표시
								<div className='containerScroll' style={{ ...styles.groupContainer }} onClick={() => handleItemPress(`QssSettingMnemonicPassword`, index)} >
									<div key={index} style={{ 
										...styles.item, 
										backgroundColor: theme.fill_normal,
										border: item.mnemonicHash === localMnemonicHash ? `1px solid ${theme.primary_normal}` : `1px solid ${theme.line_neutral}`
									}}>
										{/* <CustomText style={{ ...styles.itemNetworkText, color: theme.label_strong }}>{item.network}</CustomText> */}
										{item.name && (
											<CustomText style={{ ...styles.extraText, color:theme.text_01 }}>{item.name}</CustomText>
										)}
										<div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
											{item.mnemonicHash === localMnemonicHash && (
												<Check size={20} color={theme.primary_normal} />
											)}
											<img src="./img/icon_small_arrow_right.png" alt="arrow" style={styles.arrowIcon} />
										</div>
									</div>
								</div>
							)
						))}
					

				</div>
			)}
			
			{/* 현재지갑 QSS 니모닉해시에 저장 안된 상태 - QSS 니모닉 데이터 있음:QSS 니모닉리스트 표시, QSS 니모닉데이터 없음: QSS 없음 표시, QSS에 저장버튼 표시*/}
			{false === IsSavedQssMnemonic && (
				<div style={{ width: "100%" }}>

					{/* QSS에 안전하게 저장 버튼 */}
					<CustomText style={{ ...styles.sectionTitleTop, color: theme.text_05 }}>
						{t('qss_setting_screen_message_06')}
					</CustomText>
					<div className='containerScroll' style={{ ...styles.groupContainer }}>
						{qssMnemonicHashList.length >= maxQssMnemonicCount ? (
							<>
							<div
								key={1}
								style={{
									...styles.item,
									borderColor: theme.divider_background_03,
									backgroundColor: theme.divider_background_02,
									...styles.topRounded,
									...styles.bottomRounded,
								}}
								onClick={() => {}}
							>
								<CustomText style={{ ...styles.itemText, color: theme.text_01 }}>
									{t('qss_setting_screen_message_07')}
								</CustomText>
							</div>
							<CustomButton
									containerStyle={{
										...styles.buttonPrimary,
										backgroundColor: theme.primary_disable,
										padding: '12px',
									}}
									textStyle={{ ...styles.buttonPrimaryText }}
									onPress={() => {}}
									text={t('qss_setting_screen_message_08')}
									withBackground={true}
									backgroundColor={theme.background_08}
									disabled={true}
								/>
							</>
						) : (
							<>
								<div
									key={1}
									style={{
										...styles.item,
										borderColor: theme.divider_background_03,
										backgroundColor: theme.divider_background_02,
										...styles.topRounded,
										...styles.bottomRounded,
									}}
									onClick={() => {}}
								>
									<CustomText style={{ ...styles.itemText, color: theme.text_01 }}>
										{t('qss_setting_screen_message_05')}
									</CustomText>
								</div>
								<CustomButton
									containerStyle={{
										...styles.buttonPrimary,
										backgroundColor: theme.primary_normal,
									}}
									textStyle={{ ...styles.buttonPrimaryText }}
									onPress={() => { handleNewQssMnemonic() }}
									text={t('qss_setting_screen_message_04')}
									withBackground={true}
									backgroundColor={theme.background_08}
								/>
							</>
						)}
					</div>
					
					{/* QSS 리스트 */}
					<CustomText style={{ ...styles.sectionTitle, color: theme.text_05 }}>
						{t('qss_setting_screen_message_01')}
						{/* {selNetworkName} */}
					</CustomText>
					<div className='containerScroll' style={{ ...styles.groupContainer }}>
						{/* QSS 니모닉에 저장된 데이터가 없음 */}
						{false === usingQssMnemonic && (
							<>
							<div
								key={1}
								style={{
									...styles.item,
									borderColor: theme.divider_background_03,
									backgroundColor: theme.divider_background_02,
									...styles.topRounded,
									...styles.bottomRounded,
								}}
								onClick={() => {}}
								>
								<CustomText style={{ ...styles.itemText, color: theme.text_01 }}>
									{t('qss_setting_screen_message_03')}
								</CustomText>
							</div>
							</>
						)}

						{/* QSS 니모닉에 저장된 데이터가 있음 */}
						{true === usingQssMnemonic && (
							<>
							<div style={{ ...styles.groupContainer }}>
								{qssMnemonicHashList.map((item, index) => (
									item.network.toLowerCase() === selNetworkName.toLowerCase() && ( // 네트워크 일치 조건 추가
									
										<div
											key={index}
											style={{
												...styles.item,
												borderColor: theme.divider_background_03,
												backgroundColor: theme.divider_background_02,
												...(index === 0 ? styles.topRounded : {}),
												...(index === items.length - 1 ? styles.bottomRounded : {}),
											}}
											onClick={() => handleItemPress(`QssSettingMnemonicPassword`, index)}
										>
											{/* <CustomText style={{ ...styles.itemText, color: theme.text_01 }}>{item.network}</CustomText> */}
											{item.name && (
												<CustomText style={{ ...styles.extraText, color: theme.text_01 }}>{item.name}</CustomText>
											)}
											<img src="./img/icon_small_arrow_right.png" alt="arrow" style={styles.arrowIcon} />
										</div>

									)
								))}
							</div>
							</>
						)}
					</div>
				</div>
			)}

			{
				isDeleteModalVisible && (
					<div style={styles.modalBackground}>
						<div style={{ ...styles.modalContainer, backgroundColor: theme.modal_background_02 }}>
							<CustomText weight="bold" style={{ ...styles.modalTitle, color: theme.text_17 }}>
								{t('security_setting_screen_message_09')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_10')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_11')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_12')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_13')}
							</CustomText>

							<div style={styles.modalButtons}>
								<button
									style={styles.cancelButton}
									onClick={() => setDeleteModalVisible(false)}
								>
									<CustomText style={{ ...styles.cancelButtonText, color: theme.label_strong }}>
										{t('security_setting_screen_message_14')}
									</CustomText>
								</button>
								<button
									style={styles.confirmButton}
									onClick={handleQssClearPress}
								>
									<CustomText style={{ ...styles.confirmButtonText, color: theme.text_17 }}>
										{t('security_setting_screen_message_15')}
									</CustomText>
								</button>
							</div>
						</div>
					</div>
				)
			}
			{
				showPinCodeAuth && (
					<div style={styles.modalBackground}>
						<PinCodeScreen onSuccess={handleQssPasswordAuthSuccess} unlock={false} />
					</div>
				)
			}
		</div >
	)
}

export default QssSettingMnemonicScreen
